import React, { useEffect, useState } from 'react';
import {
    CircularProgress,
    Grid, Typography
} from "@material-ui/core/";
import { Link } from 'react-router-dom';
import FormBase from '../../../../forms/FormBase';
import Controls from '../../../../components/controls/Controls';
import TermsDeclarationsService from '../../../../services/TermsDeclarationsService';
import TermsDeclarations from '../../../../models/TermsDeclarations';
import { ModalHandle } from '../../../../components/controls/Modal';
import TmpHtmlContentCustom from '../../../../components/tempo/TmpHtmlContentCustom/TmpHtmlContentCustom';

interface ImmunityDeclarationProps {
    Name: string;
    Checked: boolean;
    onCheckedClick: (e: any) => void
    onInputChange: (name: string, form: FormBase, value: any) => void
}

export default function ImmunityDeclaration(props: ImmunityDeclarationProps) {


    const [checkedTerm, setCheckedTerm] = useState(props.Checked);

    const modalRef = React.createRef<ModalHandle>();

    const handleOpenModalChild = () => {
        modalRef.current?.handleOpen()
    };

    const [text, setText] = useState<string>("")
    const [title, setTitle] = useState<string>("")
    const [id, setId] = useState<number>(0)

    useEffect(() => {

        TermsDeclarationsService.getCurrentTermsDeclarations("DECL_IMUNIDADE_HEPATITE_B").then(e => {

            if (e) {
                var textTerm = e.description;

                textTerm = textTerm.replace("#{props.Name}", props.Name)

                setText(textTerm)
                setTitle(e.title)
                setId(e.textId);
            }
        })

    }, [props.Name])

    const handleCheckdTerm = (e: any) => {
        setCheckedTerm(e.target.value);
        props.onCheckedClick(new TermsDeclarations(id, e.target.value));
    }

    return (
        <Grid item xs={12} sm={12}>

            {
                id === undefined || id === 0 ?
                    <Grid container justifyContent="center" style={{ width: "85%" }} >
                        <CircularProgress />
                    </Grid>
                    :
                    <Controls.Checkbox
                        name="ImmunityDeclaration"
                        labelComponent={
                            <div>
                                <span>Li e estou de acordo com a  </span>
                                <Link to={'#'} onClick={() => handleOpenModalChild()}>Declaração de Imunidade Prévia ao Vírus da Hepatite B.</Link>
                            </div>
                        }
                        value={checkedTerm}
                        onChange={handleCheckdTerm}
                    />
            }


            <Controls.Modal ref={modalRef} title={title}>

                <Typography variant="body1" gutterBottom component="div">
                    <TmpHtmlContentCustom html={text} />
                </Typography>

            </Controls.Modal>
        </Grid>
    );
}

